import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Container, Flashbar, Form, FormField, Input, Modal, RadioGroup, SegmentedControl, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

export const MembersEtcRiskPage = () => {
    const { idUser, data, menu, parameters } = useGlobalState();
    useGlobalState();



    const [preFlights, setPreflights] = useState<any[]>([]);
    const [preFlight, setPreflight] = useState<any>();
    const [preFlightSend, setPreflightSend] = useState<any>();
    const [preFlightEval, setPreFlightEval] = useState<any>();
    const [preFlightResult, setPreFlightResult] = useState<any>();
    const [selectedPreFlight, setSelectedPreFlight] = useState("");

    const handleGetPreFlights = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/edv/risk/preflights/list',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify({})
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.preFlights) {
                setPreflights(data.preFlights);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleSetPreFlight = async () => {
        try {
            const preFlightSend2 = {
                result: preFlightSend,
                idPreFlight: preFlight?.idPreFlight,
            }
            //console.log(preFlightSend2);
            //return;
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/edv/risk/add',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify(preFlightSend2)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.code === 0) {
                setPreFlightEval(undefined);
                setPreflight(undefined);
                setPreflightSend(undefined);
                setSelectedPreFlight("");
                setPreFlightResult(data.result);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        handleGetPreFlights();
    }, []);
    useEffect(() => {
        if (!preFlight?.data?.subTypes) {
            setPreflightSend(undefined);
            return;
        }

        // 1. Create a deep copy to perform calculations
        const newData = JSON.parse(JSON.stringify(preFlight.data));
        const incompleteQuestion = newData.subTypes
            .flatMap((subType: any) => subType.questions)
            .find((question: any) => question.result !== 1);

        if (incompleteQuestion) {
            setPreflightSend(undefined);
            return;
        }

        if (newData) {

            newData.subTypes.forEach((subType: any) => {
                subType.result = 0;
                subType.questions.forEach((question: any) => {
                    // NUMERIC.RANGE Logic
                    if (question.type === "NUMERIC.RANGE") {
                        //console.log(question.ranges, question.value)
                        const match = question.ranges.find((r: any) =>
                            question.value >= r.low && question.value <= r.high
                        );

                        if (match) {
                            //console.log(match.weight, question.weight)
                            question.eval = question.weight * match.weight * 10;
                            match.result = 1;
                            subType.result += question.eval;
                            //console.log(question.eval, subType.result)
                        }
                    }
                    // OPTION Logic
                    else if (question.type === "OPTION") {
                        if (!!question.result && question.value >= 0 && question.weight) {
                            question.eval = question.weight * question.value;
                            subType.result += question.eval;

                            question.ranges.forEach((r: any) => {
                                if (question.answer === r.weight) r.result = 1;
                            });
                        }
                    }
                });
            });

            // Final calculation
            const rawScore = (newData.subTypes[0]?.result || 0) * (newData.subTypes[1]?.result || 0);
            const score = Math.round(rawScore * 1000) / 1000;

            newData.results = newData.results || {};
            newData.results.score = score;

            const actionMatch = newData.actions.find(
                (action: any) => score >= action.low && score < action.high
            );
            if (actionMatch) {
                newData.results.action = actionMatch.title;
                newData.results.result = newData.actions.indexOf(actionMatch);
            }
            //console.log(newData)
            setPreflightSend(newData);
        }

    }, [preFlight]);


    const isComplete = preFlightSend && preFlightSend.subTypes.every((subType: any) =>
        subType.questions.every((question: any) => question.result === 1)
    );

    const options = preFlights.map((preFlight: any) => ({
        text: preFlight.preFlight,
        id: preFlight.preFlightType
    }));


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Mitigación de riesgo</Header>
                    {preFlights.length > 0 && (
                        <FormField label="Tipo de vuelo" description="Lista de pre-vuelos">
                            <SegmentedControl
                                selectedId={selectedPreFlight}
                                onChange={({ detail }) => {
                                    setSelectedPreFlight(detail.selectedId)
                                    setPreflight(preFlights.find((preFlight: any) => preFlight.preFlightType === detail.selectedId))
                                }}

                                options={options}
                            />
                        </FormField>
                    )}
                    {preFlight && (
                        <Form
                            actions={<Button variant="primary"
                                disabled={!isComplete}
                                onClick={() => {
                                    handleSetPreFlight();


                                }}>Evaluar</Button>}
                            secondaryActions={<Button variant="link" onClick={() => {
                                setPreflight(undefined)
                                setSelectedPreFlight("")
                            }}>Cancelar</Button>}
                        >
                            <SpaceBetween size="l">

                                {preFlight.data.subTypes.map((subType: any, index: number) => (
                                    <React.Fragment key={index}>
                                        <Container header={
                                            <Header>{subType.title}</Header>}>
                                            <SpaceBetween size="l">
                                                {
                                                    subType.questions.map((question: any, qIndex: number) => (
                                                        <FormField
                                                            key={qIndex} // Added key here as well for good practice
                                                            label={question.question}
                                                            description={question.subQuestion}
                                                        >
                                                            {question.type === "NUMERIC.RANGE" && (
                                                                <Input
                                                                    autoComplete="off"
                                                                    value={question?.value?.toString()}
                                                                    onChange={({ detail }) => {
                                                                        const cleanValue = detail.value.replace(/\D/g, "");

                                                                        let numericValue = cleanValue;
                                                                        let newValue = null;
                                                                        if (numericValue !== "") {
                                                                            newValue = parseInt(cleanValue, 10);
                                                                        }
                                                                        setPreflight((prev: any) => {
                                                                            const newData = { ...prev.data };
                                                                            newData.subTypes = [...newData.subTypes];
                                                                            newData.subTypes[index] = { ...newData.subTypes[index], result: 0 };
                                                                            newData.subTypes[index].questions = [...newData.subTypes[index].questions];
                                                                            newData.subTypes[index].questions[qIndex] = {
                                                                                ...newData.subTypes[index].questions[qIndex],
                                                                                value: newValue,
                                                                                result: numericValue.toString() !== "" ? 1 : 0,
                                                                            };
                                                                            return { ...prev, data: newData };
                                                                        });
                                                                    }}
                                                                />
                                                            )}

                                                            {question.type === "OPTION" && (
                                                                <RadioGroup
                                                                    items={question.ranges.map((range: any, index: number) => ({
                                                                        ...range,
                                                                        value: index.toString(),
                                                                        label: range.title,
                                                                        index: index,
                                                                    }

                                                                    ))}
                                                                    value={question.answer}
                                                                    onChange={({ detail }) => {
                                                                        setPreflight((prev: any) => {
                                                                            const newData = { ...prev.data };
                                                                            newData.subTypes = [...newData.subTypes];
                                                                            newData.subTypes[index] = { ...newData.subTypes[index], result: 0 };
                                                                            newData.subTypes[index].questions = [...newData.subTypes[index].questions];
                                                                            newData.subTypes[index].questions[qIndex] = {
                                                                                ...newData.subTypes[index].questions[qIndex],
                                                                                answer: detail.value,
                                                                                value: newData.subTypes[index].questions[qIndex].ranges[parseInt(detail.value)].weight,
                                                                                result: 1,
                                                                            };
                                                                            return { ...prev, data: newData };
                                                                        });
                                                                    }}
                                                                />
                                                            )}


                                                        </FormField>
                                                    ))
                                                }
                                            </SpaceBetween>
                                        </Container>
                                    </React.Fragment>
                                ))}
                            </SpaceBetween>
                        </Form>
                    )}
                    <Modal

                        visible={!!preFlightResult} header={"Resultado de la evaluación"}
                        footer={
                            <Box float="right">
                                <Button variant="link" onClick={() => {
                                    setPreFlightEval(undefined)
                                    setPreflight(undefined)
                                    setPreflightSend(undefined)
                                    setSelectedPreFlight("")
                                    setPreFlightResult(undefined)
                                }}>
                                    Cerrar
                                </Button>
                            </Box>
                        }

                    >
                        <Flashbar items={[
                            {
                                type: preFlightResult?.result === 0 ? "success" : preFlightResult?.result === 1 ? "warning" : preFlightResult?.result === 2 ? "error" : "info",
                                content: (
                                    <SpaceBetween size="s">
                                        <Box>
                                            <strong>Puntaje:</strong> {preFlightResult?.score ?? "N/A"}
                                        </Box>
                                        <Box>
                                            <strong>Acción recomendada:</strong> {preFlightResult?.action ?? "N/A"}
                                        </Box>
                                    </SpaceBetween>
                                ),
                                dismissible: false,
                            }
                        ]} />
                    </Modal>

                </SpaceBetween>
            }
        />
    )
};
